
import api from '@edu-fe/api'
import style from '@style/list.module.scss'

import InfiniteLoading from 'vue-infinite-loading'
import CourseItem from '@pui/CourseItem'

import { getBarEnable } from '../../bar/utils'

const requests = {
  getCategories: api.create('/category/config'),
  getCourses: api.create('/category/courses'),
  getTypeCourses: api.create('/operation/page')
}

export default {
  data () {
    return {
      id: '', // 分类id
      type: '', // 打包课id
      infiniteId: 0, // 用于切换
      topList: [],
      mainList: [],
      pageSize: 5,
      pageNo: 0,
      underBar: false
    }
  },

  methods: {
    async getTop () {
      const { data } = await requests.getCategories()

      // 把 "全部" 拿到最后面
      for (let index = 0; index < data.length; index++) {
        const item = data[index]

        if (item.title === '全部') {
          if (index !== data.length - 1) {
            const [ last ] = data.splice(index, 1)
            data.push(last)
          }
          break
        }
      }

      this.topList = data
    },

    // 检查是否有bar在上面
    checkBar () {
      let count = 0
      let timer = setInterval(() => {
        count++
        if (count > 10) {
          return clearInterval(timer)
        }
        this.underBar = getBarEnable()
      }, 500)
    },

    onTopClick (item) {
      this.$router.replace(`/list/${item.categoryId}`)
    },

    async getList ($state) {
      // $state 上滑加载的组件状态, 未传表示进入页面或切换tab
      let res

      if (!$state) {
        this.$loading.show()
      }

      if (this.type) {
        res = await requests.getTypeCourses({
          type: this.type,
          pageNo: this.pageNo++,
          pageSize: this.pageSize
        })
      } else {
        res = await requests.getCourses({
          categoryId: this.id,
          pageNo: this.pageNo++,
          pageSize: this.pageSize
        })
      }

      const { data: { list } } = res

      if (this.pageNo === 2) {
        this.mainList = list
      } else {
        this.mainList.push(...list)
      }

      if (list.length >= this.pageSize) {
        setTimeout(() => $state && $state.loaded(), 1500)
      } else {
        setTimeout(() => $state && $state.complete(), 1500)
      }

      if (!$state) {
        setTimeout(() => this.$loading.hide(), 500)
      }
    },

    onListClick (item) {
      this.$router.push(`/sign-up?courseId=${item.id}`)
    },

    async onReachBottom ($state) {
      if (this.id) {
        await this.getList($state)
      } else {
        // 页面进入时, 会触发两次列表加载, 但pageNo都是1
        $state.complete()
      }
    }
  },

  // 处理分类切换
  beforeRouteUpdate (to, from, next) {
    this.id = to.params.id
    this.infiniteId++
    this.pageNo = 1
    this.getList()
    next()
  },

  async created () {
    const { id, type } = this.$route.params

    this.checkBar()

    if (id === 'type') {
      this.type = type
    } else {
      await this.getTop()
      this.id = id || this.topList[0].categoryId
    }

    // 页面进入时, 关掉下拉加载, 手动加载列表, 然后打开下拉加载
    await this.getList()
    this.infiniteId++
    !this.id && (this.id = 'type') // 设置id, 启用下拉加载
  },

  render () {
    const {
      id, // from this.data
      infiniteId, // from this.data
      topList, // from this.data
      mainList, // from this.data
      underBar, // from this.data
      onTopClick, // from this.methods
      onListClick, // from this.methods
      onReachBottom // from this.methods
    } = this

    return (
      <main>
        {
          topList.length > 0 && <ul class={{
            [style.top]: true,
            [style.topUnder]: underBar
          }}>
            {
              topList.map(item => (
                <li
                  class={{
                    [style.topItem]: true,
                    [style.topItemActive]: item.categoryId === id
                  }}
                  onClick={() => onTopClick(item)}
                >{item.title}</li>
              ))
            }
          </ul>
        }

        <ul class={{
          [style.main]: true,
          [style.mainTop]: topList.length > 0
        }}>
          {
            mainList.map(item => (
              <li class={style.mainItem}>
                <CourseItem
                  dataSource={item}
                  dataType='list'
                  styleType='3'
                  onClick={() => onListClick(item)}
                />
              </li>
            ))
          }

          <InfiniteLoading onInfinite={onReachBottom} identifier={infiniteId}>
            <div class={style.noMore} slot='no-more'>没有更多的课程了</div>
            <div class={style.noResults} slot='no-results'>暂无课程</div>
          </InfiniteLoading>
        </ul>
      </main>
    )
  }
}
